import { Injectable } from '@angular/core';
import { ActivatedRoute, ActivatedRouteSnapshot, NavigationEnd, Router } from '@angular/router';
import { RiskModuleConfig } from '../agility-risk.config.interface';
import { LocalStorageService } from 'angular-2-local-storage';
import { defaultHomeAddress, defaultModuleBaseAddress, storageKeys } from '../agility-risk.constants';
import { Observable, Subject } from 'rxjs';
import { HostChangedData } from '../models/hostChangedData';
import { NavHistory } from '../models/nav-history';

export class NavigationServiceConfig {
  showBreadcrumb: boolean;
  moduleBaseAddress: string;
  appHomeAddress: string;
}

@Injectable({
  providedIn: 'root'
})

export class AgilityRiskNavigationService {
  private navigationConfig: NavigationServiceConfig;
  private onNavigationChangedSubject: Subject<any> = new Subject<any>();
  private firstPass: boolean;

  constructor(private router: Router,
              private route: ActivatedRoute,
              private storage: LocalStorageService,
              private config: NavigationServiceConfig) {
    this.navigationConfig = config;
    this.firstPass = true;
  }

  get showBreadcrumb(): boolean {
    return this.navigationConfig?.showBreadcrumb === true;
  }

  get moduleBaseAddress(): string {
    return this.navigationConfig?.moduleBaseAddress || defaultModuleBaseAddress;
  }

  get appHomeAddress(): string {
    return this.navigationConfig?.appHomeAddress || defaultHomeAddress;
  }

  get navigationHistory(): Array<NavHistory> {
    return this.storage.get(storageKeys.navigationHistory) || [];
  }

  onNavigationChanged(): Observable<HostChangedData> {
    return this.onNavigationChangedSubject.asObservable();
  }

  navigationChanged(): void {
    this.onNavigationChangedSubject.next();
  }

  setNavigationHistory(evt: NavigationEnd, key: string): void {
    const navHistory: Array<NavHistory> = this.storage.get(storageKeys.navigationHistory) || [];
    if (key) {
      const idx: number = navHistory.findIndex(n => n.key === key);

      if (this.firstPass) {
        if (idx === -1) {
          navHistory.length = 0;
        }
        this.firstPass = false;
      }
      if (idx === -1) {
        navHistory.push(new NavHistory(key, evt.urlAfterRedirects));
      } else if (idx !== navHistory.length - 1) {
        navHistory.splice(idx + 1);
      }
      this.storage.set(storageKeys.navigationHistory, navHistory);
      this.navigationChanged();
      // console.log(JSON.stringify(navHistory));
    }
  }

  clearNavHistory(): void {
    this.storage.remove(storageKeys.navigationHistory);
  }

  getResolvedUrl(route: ActivatedRouteSnapshot): string {
    return route.pathFromRoot
      .filter(v => v.routeConfig == null || v.routeConfig.path !== '')
      .map(v => v.url.map(segment => segment.toString()).join('/'))
      .join('/');
  }
}

export function provideNavigationServiceConfig(riskModuleConfig?: RiskModuleConfig): NavigationServiceConfig {
  const navigationServiceConfig = new NavigationServiceConfig();

  if (riskModuleConfig) {
    navigationServiceConfig.showBreadcrumb = riskModuleConfig?.showBreadcrumb || false;
    navigationServiceConfig.moduleBaseAddress = riskModuleConfig.moduleBaseAddress || defaultModuleBaseAddress;
    navigationServiceConfig.appHomeAddress = riskModuleConfig.appHomeAddress || defaultHomeAddress;
  }

  return (navigationServiceConfig);
}

